var map = {
	"./0-top.vue": 96116,
	"./2-top_sidebar.vue": 65616,
	"./30-beauty_alive.vue": 62001,
	"./40-beauty.vue": 83594,
	"./50-zhi.vue": 12475,
	"./54-voice.vue": 42850,
	"./58-assistant.vue": 81183,
	"./60-new.vue": 10846,
	"./62-aiplaygroud.vue": 37898,
	"./70-last.vue": 60741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23896;